<template>
  <div>
    <div style="margin-top: 8px; margin-left: 8px">
      <el-button @click="getList"> 查询 </el-button>
      <el-button @click="handleAdd"> 添加地区 </el-button>
    </div>

    <el-table
      style="margin-top: 8px; margin-left: 8px"
      max-height="600"
      :data="listData"
      border v-loading="tableVisible"
    > 
    <el-table-column label="名称" prop="name"></el-table-column>
    <el-table-column label="战区/片区数量" prop="zone_count"></el-table-column>
    <el-table-column label="排序" prop="sort"></el-table-column>
    <el-table-column label="操作">
      <template slot-scope="scope">
        <el-button @click="handleUpdate(scope.row)" type="text" size="small">修改</el-button>
        <el-button @click="del(scope.row.id)" type="text" size="small">删除</el-button>
        <el-button @click="handleZoneChange(scope.row)" type="text" size="small">管理战区</el-button>
      </template>
    </el-table-column>
    </el-table>

    <el-pagination
      style="margin-top: 8px; margin-left: 8px"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pagination.page"
      :page-sizes="[10, 20, 30, 40]"
      :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
    ></el-pagination>

    <el-dialog :visible.sync="formVisible" title="添加/修改地区">
      <el-form ref="form" :model="form" label-width="80px" :rules="formRules">
        <el-form-item label="名称" prop="name">
          <el-input v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="排序">
          <el-input v-model="form.sort"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="sendData">确定</el-button>
          <el-button @click="formVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <el-dialog :visible.sync="zoneVisible" title="战区管理">
      <el-form>
        <el-form-item>
          <el-checkbox-group v-model="zoneCheck">
            <el-checkbox v-for="item in zoneList" :label="item.id" :key="item.id">{{ item.name }}</el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="saveZone">确定</el-button>
          <el-button @click="zoneVisible = false">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default
{
  mounted(){
    this.getList();
  },
  data(){
    return {
      listData: [],
      tableVisible : false,
      pagination : {
        page : 1,
        pageSize : 10,
        total : 0,
      },
      formVisible : false,
      form : {
        id : 0,
        name : '',
        sort : 0,
      },
      formRules : {
        name : [
          { required : true, message : '请输入名称', trigger : 'blur' },
        ],
      },
      zoneVisible : false,
      zoneList : [],
      zoneCheck : [],
      zoneId : 0,
    };
  },
  methods : {
    // 地区列表
    getList(){
      let that = this;
      this.tableVisible = true;
      this.$myhttp.get("admin/PindexPlace/getList",
          { page : this.pagination.page , page_size : this.pagination.pageSize },{
            "Content-Type": "application/json",
          }).then(res => {
            if(res.data.code == 200){
              that.listData = res.data.data.list;
              that.pagination.total = res.data.data.total;
              that.$message.success(res.data.msg);
            }else{
              that.$message.error(res.data.msg);
            }
            this.tableVisible = false;
      });
    },
    handleCurrentChange(page){
      this.pagination.page = page;
      this.getList();
    },
    handleSizeChange(page_size){
      this.pagination.page = 1;
      this.pagination.pageSize = page_size;
      this.getList();
    },
    sendData(){
      this.$myhttp.post("admin/PindexPlace/save",
        this.form,{
          "Content-Type": "application/json",
        }).then(res => {
          if(res.data.code == 200){
            this.formVisible = false;
            this.getList();
            this.$message.success(res.data.msg);
          }else{
            this.$message.error(res.data.msg);
          }
      });
    },
    handleAdd(){
      this.formVisible = true;
      this.form = {
        id : 0,
        name : '',
        sort : 0,
      };
    },
    handleUpdate(row){
      this.formVisible = true;
      this.form = {
        id : row.id,
        name : row.name,
        sort : row.sort,
      };
    },
    del(id){
      this.$confirm('确定删除吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$myhttp.post("admin/PindexPlace/del",
        { id },{
          "Content-Type": "application/json",
        }).then(res => {
            if(res.data.code == 200){
              this.getList();
              this.$message.success(res.data.msg);
            }else{
              this.$message.error(res.data.msg);
            }
          });
      })
    },
    getZoneList(){
      this.$myhttp.post("admin/ZoneManage/index",
        { page : 0 , page_size : 0 },
        { "Content-Type": "application/json" }).then(res => {
            if(res.data.code == 200){
              this.zoneList = res.data.data;
            }else{
              this.$message.error(res.data.msg);
            }
      });
    },
    handleZoneChange(row){
      this.zoneVisible = true;
      this.zoneCheck = row.zone_id.split(',');
      this.zoneId = row.id;
      // 正数
      for(let i = 0; i < this.zoneCheck.length; i++){
        if(this.zoneCheck[i] > 0){
          this.zoneCheck[i] = parseInt(this.zoneCheck[i]);
        }
      }
      this.getZoneList();
    },
    saveZone(){
      this.$confirm('确定提交？' , '提示' , {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$myhttp.post("admin/PindexPlace/saveZone",{
        id : this.zoneId , 
        zone_id : this.zoneCheck.join(',')
      },{
        "Content-Type": "application/json"
      }).then(res => {
        if(res.data.code == 200){
          this.zoneVisible = false;
          this.getList();
          this.$message.success(res.data.msg);
        }else{
          this.$message.error(res.data.msg);
        }
      });
      })
    },
  }
}
</script>

<style scoped lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Admin/Project/Place.vue